import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../assets/icons/google-play.png';
import _imports_1 from './../assets/icons/apple-button.png';
import _imports_2 from './../assets/icons/webgl-button.png';
import _imports_3 from '@/assets/icons/facebook.png';
import _imports_4 from '@/assets/icons/discord.png';
import _imports_5 from '@/assets/icons/twitter.png';
import _imports_6 from '@/assets/icons/telegram.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-4f5d1925"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "footer" };
var _hoisted_2 = { class: "content-wrap" };
var _hoisted_3 = { class: "content" };
var _hoisted_4 = { class: "col-np-12" };
var _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-8 col-md-8 col-sx-8\" data-v-4f5d1925><a href=\"https://play.google.com/store/apps/details?id=com.btc.dwarves\" target=\"_blank\" data-v-4f5d1925><img class=\"store-icon\" src=\"" + _imports_0 + "\" data-v-4f5d1925></a><a href=\"https://apps.apple.com/lv/app/miners-rush/id6499256659\" target=\"_blank\" data-v-4f5d1925><img class=\"store-icon\" src=\"" + _imports_1 + "\" data-v-4f5d1925></a><a href=\"https://play.minersrush.xyz/v114/\" target=\"_blank\" data-v-4f5d1925><img class=\"store-icon\" src=\"" + _imports_2 + "\" data-v-4f5d1925></a><div class=\"col-np-12 col-np-md-12 col-np-xs-12 soc-icons\" data-v-4f5d1925><a href=\"https://www.facebook.com/profile.php?id=61556222266248\" target=\"_blank\" data-v-4f5d1925><img src=\"" + _imports_3 + "\" data-v-4f5d1925></a><a href=\"https://discord.gg/Cn2KMehEvE\" target=\"_blank\" data-v-4f5d1925><img src=\"" + _imports_4 + "\" data-v-4f5d1925></a><a href=\"https://twitter.com/MinersRush\" target=\"_blank\" data-v-4f5d1925><img src=\"" + _imports_5 + "\" data-v-4f5d1925></a><a href=\"https://t.me/minersrushnews\" target=\"_blank\" data-v-4f5d1925><img src=\"" + _imports_6 + "\" data-v-4f5d1925></a></div></div>", 1);
var _hoisted_6 = { class: "col-4 col-md-4 col-sx-4" };
var _hoisted_7 = { class: "footer-menu" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return ($data.router.push('/about')); })
                                }, "About Us")
                            ]),
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return ($data.router.push('/prizes')); })
                                }, "Prizes")
                            ]),
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return ($data.router.push('/contact')); })
                                }, "Contact Us")
                            ]),
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[3] || (_cache[3] = function ($event) { return ($data.router.push('/faq')); })
                                }, "FAQ")
                            ]),
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[4] || (_cache[4] = function ($event) { return ($data.router.push('/terms_and_conditions')); })
                                }, "Terms & Conditions")
                            ]),
                            _createElementVNode("span", null, [
                                _createElementVNode("a", {
                                    class: "font-ris",
                                    onClick: _cache[5] || (_cache[5] = function ($event) { return ($data.router.push('/privacy_policy')); })
                                }, "Privacy Policy")
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
